import SectionLabel from "./SectionLabel";
import DossierStamp from "./DossierStamp";
import Marquee from "./Marquee";
import { FadeUp, MaskLine } from "./Reveal";

export default function Exchange() {
  return (
    <section data-testid="exchange-section" className="relative bg-wine text-bone">
      <div className="absolute -top-10 right-6 z-10 md:right-16">
        <DossierStamp
          testid="exchange-stamp"
          title="ACCESS GRANTED"
          sub="INTELLIGENCE EXCHANGE //"
          rotate={-10}
          className="bg-bone shadow-[0_20px_40px_-20px_rgba(0,0,0,0.5)]"
        />
      </div>

      <div className="mx-auto max-w-7xl px-6 py-32 md:px-10 md:py-44">
        <SectionLabel light testid="exchange-label">
          The Room Is A Resource
        </SectionLabel>

        <h2 className="max-w-4xl font-serif text-4xl font-medium leading-[1.08] tracking-tight sm:text-5xl lg:text-6xl">
          <MaskLine>You are not coming to RECON</MaskLine>
          <MaskLine delay={0.1}>
            simply to consume. <span className="italic text-manila">You are coming to gather.</span>
          </MaskLine>
        </h2>

        <div className="mt-16 grid gap-14 md:grid-cols-2">
          <FadeUp delay={0.15} className="space-y-6 text-base leading-relaxed text-bone/75 md:text-lg">
            <p>
              And to contribute. Every woman in the room carries intelligence. Experience. Access.
              Relationships. Expertise. Perspective. Wisdom earned through things she survived,
              built, lost, learned, prayed through, and discovered.
            </p>
            <p>At The Intelligence Exchange, connection becomes more than networking.</p>
          </FadeUp>
          <div className="space-y-8">
            <FadeUp delay={0.25}>
              <p className="font-sans text-[11px] tracking-[0.35em] text-bone/50">
                THE QUESTION ISN'T SIMPLY:
              </p>
              <p className="mt-3 font-serif text-2xl italic text-bone/60 md:text-3xl">
                "Who can help me?"
              </p>
            </FadeUp>
            <FadeUp delay={0.35}>
              <p className="font-sans text-[11px] tracking-[0.35em] text-bone/50">
                THE QUESTION BECOMES:
              </p>
              <p className="mt-3 font-serif text-2xl leading-snug text-bone md:text-3xl">
                "What intelligence exists in this room —{" "}
                <span className="italic">and what do I carry that someone else may need?</span>"
              </p>
            </FadeUp>
          </div>
        </div>
      </div>

      <Marquee dark testid="exchange-marquee" items={["THE ROOM IS A RESOURCE"]} />
    </section>
  );
}
